import { useEffect, useState } from 'react';
import { captureUtm, getUtm, type Utm } from './utm';

/**
 * The visitor's UTM, for use while rendering. `{}` on the server and on the first client
 * render, so hydrated markup matches the server's (React 19 keeps the server's attribute on a
 * mismatch, which would silently drop the UTM from a link). Then the captured values.
 *
 * Captures rather than only reading: an island can't rely on another script having copied
 * the landing URL's UTM into storage first, because module script order isn't guaranteed.
 * captureUtm is idempotent. The hook then returns getUtm()'s merged view of session and local
 * storage (local wins), not captureUtm's session-only result, since the app persists to
 * localStorage.
 */
export function useUtm(): Utm {
  const [utm, setUtm] = useState<Utm>({});

  useEffect(() => {
    captureUtm('session');
    setUtm(getUtm());
  }, []);

  return utm;
}
